const serviceApi = [
    {
        id: 1,
        logo: "fas fa-download",
        title: "IIT JEE (MAIN + ADVANCE) CLASSES",
        info: "Doubtnut Provide you all subject lecture and courses of IIT JEE (MAINs & ADVANCE). It's taking all live lecture of all subjects in a daily routine for better performance. Their teacher are very good because they are also An IITian.",
    },
    {
        id: 2,
        logo: "fas fa-user-check",
        title: "CBSE / ICSE CLASSES",
        info: "Doubtnut Provide you CBSE and ICSE subject lecture and courses of IIT JEE. It's taking all live lecture of all subjects in a daily routine for better performance. Their teacher are very good because they are also An IITian."
    },
    {
        id: 3,
        logo: "fas fa-money-check-alt",
        title: "STATE BOARD CLASSES",
        info: "Doubtnut Provide you All State Board classes subject lecture and live classes. It's taking all live lecture of all subjects in a daily routine for better performance. Their teacher are very good because they are also An IITian.",
    },
    {
        id: 4,
        logo: "fab fa-amazon-pay",
        title: "NEET (UG/ PG) CLASSES",
        info: "Doubtnut Provide you NEET UG & PG classes subject lecture and live classes. It's taking all live lecture of all subjects in a daily routine for better performance. Their teacher are very good because they are also An Doctors & IITians.",
    },
    {
        id: 5,
        logo: "fas fa-hand-holding-usd",
        title: "CONTEST & TEST SERIES",
        info: "Doubtnut Provide you all types of test series and contest to boost your preparartion one level ahead. It's making by a Experts, IITians and Doctors to it is good for everyonme.After test they giving you solution of all; question in daily basis for better performance.they are also provide by An Experts.",
    },
    {
        id: 6,
        logo: "fas fa-globe",
        title: "SEPARATE SUBJECT WISE COURSE",
        info: "Doubtnut Provide you All courses subject wise. If you want to any particular subject then you go for particular subject lecture and live classes. It's taking all live lecture of all subjects in a daily routine for better performance. Their teacher are very good because they are also An IITian.",
    },
];
export default serviceApi;